export class RadiolistPoco {
    constructor(public label: string, public valeur: string, public css: string = 'gridspan4') {}
}
